import '@availity/yup';
import * as yup from 'yup';

const formValidation = yup.object().shape({
  name: yup.string().required(),
  countryCode: yup
    .string()
    .required()
    .min(2)
    .max(2)
    .matches(/^[A-Z]{2}$/, 'Country code must be 2 uppercase letters'),
  waitingTimeRecall: yup.string().required(),
  phoneExchange: yup.string().required(),
  timezone: yup.string().required(),
  facebookModule: yup.boolean().required(),
  facebookAdAccountIds: yup.array().of(
    yup.object().shape({
      accountId: yup.string().required(),
      datasetId: yup.string(),
    }),
  ),
  facebookAccessToken: yup.string().when('facebookModule', {
    is: true,
    then: () => yup.string().required(),
  }),
  googleModule: yup.boolean().required(),
  supplierModule: yup.boolean().required(),
  audienceModule: yup.boolean().required(),
});

export default formValidation;
